import { render } from "./LossChart.vue?vue&type=template&id=65b06acf&scoped=true"
import script from "./LossChart.vue?vue&type=script&lang=js"
export * from "./LossChart.vue?vue&type=script&lang=js"

import "./LossChart.vue?vue&type=style&index=0&id=65b06acf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b06acf"]])

export default __exports__